import {
  Box,
  Stack,
  styled,
  Tooltip,
  tooltipClasses,
  TooltipProps,
} from '@mui/material';
import backoffice from 'assets/images/logo/backoffice-uppercase.png';
import logo from 'assets/images/logo/LAB-REDE-CMYK-nomal.png';
import logoDark from 'assets/images/logo/labrede-negativa.png';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const LogoWrapper = styled(Link)(
  ({ theme }) => `
        color: ${theme.palette.text.primary};
        display: flex;
        text-decoration: none;
        
        // width: 53px;
        justify-content: center;
        // margin: 0 auto 0 auto;
        font-weight: ${theme.typography.fontWeightBold};
`
);


const TooltipWrapper = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.colors.alpha.trueWhite[100],
    color: theme.palette.getContrastText(theme.colors.alpha.trueWhite[100]),
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 'bold',
    borderRadius: theme.general.borderRadiusSm,
    boxShadow:
      '0 .2rem .8rem rgba(7,9,25,.18), 0 .08rem .15rem rgba(7,9,25,.15)',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.colors.alpha.trueWhite[100],
  },
}));

interface IProps {
  logoWhite?: boolean;
}

const Logo = ({ logoWhite = true }: IProps) => {
  const { t } = useTranslation();

  return (
    <TooltipWrapper title={t('LabRede')} arrow>
      <LogoWrapper to="/">
        <Stack sx={{ margin: '10px 0px 10px 0px' }}>
          <Box
            component="img"
            src={logoWhite ? logo : logoDark}
            alt="logo labrede"
            sx={{
              padding: 0,
              width: { xs: '130px', lg: '170px' },
            }}
          />
          <Box
            component="img"
            src={backoffice}
            alt="logo labrede backoffice"
            sx={{
              padding: 0,
              alignSelf: 'center',
              width: { xs: '100px', lg: '130px' },
              marginTop: '10px',
            }}
          />
        </Stack>
        {/* <Badge
          sx={{
            '.MuiBadge-badge': {
              fontSize: theme.typography.pxToRem(11),
              right: -2,
              top: 8
            }
          }}
          overlap="circular"
          color="success"
          badgeContent="3.1"
        >
          <LogoSignWrapper>
            <LogoSign>
              <LogoSignInner />
            </LogoSign>
          </LogoSignWrapper>
        </Badge> */}
      </LogoWrapper>
    </TooltipWrapper>
  );
};

export default Logo;
